//import { MoneyLinkException } from "@/shared/utils/custom-exception";
import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { PostNewsService } from "@/features/news/services/post-news-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";


export const usePostNews = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const postNewsService = new PostNewsService();

  /*--------------------
    イベント関連
  --------------------*/
  // お知らせ既読情報登録
  const postNews = async (
    readNrcodeList: string[],
  ): Promise<boolean> => {
    loadingCtx.setIsLoading(true);
    try {
      await postNewsService.postNews({
        read_nrcode_list: readNrcodeList
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("postNews", error);
      return false;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    postNews: errorHandledAsync(postNews, setError),
  };
};
